import api from "./api";

export async function listFinanceiro() {
  const { data } = await api.get("/Financeiro");
  return data;
}

export async function getFinanceiro(id) {
  const { data } = await api.get(`/Financeiro/${id}`);
  return data;
}

// GET /api/financeiro/extrato?de=YYYY-MM-DD&ate=YYYY-MM-DD
// Retorna ExtratoResult: saldoInicial, saldoFinal, movimentos[].
export async function getExtrato(de, ate) {
  const { data } = await api.get("/Financeiro/extrato", { params: { de, ate } });
  return data;
}

export async function createFinanceiro(payload) {
  const { data } = await api.post("/Financeiro", payload);
  return data;
}

export async function updateFinanceiro(id, payload) {
  await api.put(`/Financeiro/${id}`, payload);
}

export async function deleteFinanceiro(id) {
  await api.delete(`/Financeiro/${id}`);
}
